export default "__VITE_ASSET__BnOvr2lg__"